import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

/** Encoded locally: values such as authenticator secrets never leave the browser. */
export function QrCode({ value, label }: { value: string; label: string }) {
    const [image, setImage] = useState<{ value: string; source: string } | null>(null);
    useEffect(() => {
        let active = true;
        void QRCode.toString(value, { type: 'svg', margin: 4, errorCorrectionLevel: 'M' })
            .then((svg) => {
                if (active) setImage({ value, source: `data:image/svg+xml,${encodeURIComponent(svg)}` });
            })
            .catch(() => {
                // The accompanying manual setup remains available if encoding fails.
            });
        return () => {
            active = false;
        };
    }, [value]);

    return image?.value === value ? (
        <img className="h-auto w-64 max-w-full self-center" src={image.source} alt={label} width={256} height={256} />
    ) : null;
}
